import React from 'react'
import { Link } from 'react-router-dom'
import { FaYoutube } from "react-icons/fa";
import he from 'he'

const more_Links = [
  "/videolist/annamayya-8.html",
  "/videolist/ayyappaswamideeksha-37.html",
  "/videolist/drananthalakshmi-23.html",
  "/videolist/drmuktevibharathi-39.html",
  "/videolist/mangalaharathulu-40.html",
  "/videolist/manjulasri-24.html",
  "/videolist/mylavarapusrinivasarao-32.html",
  "/videolist/shivastotram-35.html",
  "/videolist/sridevibhagavatham-9.html",
  "/videolist/sriramanavamivideos-36.html",
  "/videolist/stotralu-33.html",
  "/videolist/tiruppavai-34.html",
];

const EachRow = ({ item = {}, keyText, more_index }) => {

  function isTelugu(text) {
    const teluguRegex = /[\u0C00-\u0C7F]/;
    return teluguRegex.test(text);
  }

  return (
    <div className="devotional-section">

      {/* Section header */}
      <div className="devotional-videos-header">{keyText}</div>

      {/* Cards grid */}
      <div className="row g-0 devotional-row">
        {item.map((video, index) => {
          const url = video.video_url
            ? video.video_url.substring(video.video_url.indexOf('/devotional') + 11)
            : '';
          const title = video.video_title || 'Title';
          const imgSrc = video.video_image_url || '/devotional/assets/images/error_img.webp';

          return (
            <div key={index} className="col-6 col-sm-4 col-md-3">
              <figure className="devotional-videos-item">
                <Link to={url}>
                  <img
                    loading={index === 0 ? 'eager' : 'lazy'}
                    fetchpriority={index === 0 ? 'high' : 'auto'}
                    src={imgSrc}
                    alt={title}
                  />
                </Link>

                <FaYoutube className="dvi-icon" />

                <figcaption>
                  <Link
                    to={url}
                    style={
                      !isTelugu(title)
                        ? {
                            fontFamily:
                              "'Segoe UI', system-ui, -apple-system, 'Noto Sans Telugu', Roboto, Arial, sans-serif",
                          }
                        : {}
                    }
                    dangerouslySetInnerHTML={{__html: title ? he.decode(title) : ''}}
                  />
                 
                </figcaption>
              </figure>
            </div>
          );
        })}
      </div>

      {/* Decorative divider + More button */}
      <div className="devotional-section-divider">✦ ✦ ✦</div>
      <div className="devotional-more-wrap">
        <button className="devotional-videos-more-btn">
          <Link to={more_Links[more_index]}>More</Link>
        </button>
      </div>

    </div>
  );
};

export default EachRow;
